import { q, qq } from "../../helper/q"

import Headroom from "headroom.js"
export const stickInit = () => {
  const header = q(".header")
  if (header) {
    const headroom = new Headroom(header, { offset: 30 })
    headroom.init()
  }
}
